import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './login/register.component';
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';
import { LoginGuardGuard } from './services/guards/login-guard.guard';
import { RecpasswordComponent } from './login/recpassword.component';
import { ChangepasswordComponent } from './login/changepassword.component';
import { SeguridadComponent } from './modulos/seguridad/seguridad.component';
import { RegistraModalComponent } from './login/registra-modal.component';
import { CargaMasivaComponent } from './modulos/carga-masiva/carga-masiva.component';
import { MonitoreoComponent } from './modulos/monitoreo/monitoreo.component';
 import { EntradasComponent } from './modulos/entradas/entradas.component';
import { ConsultacomprobanteComponent } from './consultacomprobante/consultacomprobante.component';
// import { LoginEmpresaComponent } from './login/loginempresa.component';

const appRoutes: Routes = [
    // Compatibilidad con URLs legacy devueltas por perfiles/menu antiguos.
    { path: 'facturacion/facturas', redirectTo: 'facturador' },
    { path: 'facturacion/boletas', redirectTo: 'facturador' },
    { path: 'facturacion/notascredito', redirectTo: 'facturador' },
    { path: 'facturacion/notasdebito', redirectTo: 'facturador' },
    { path: 'facturacion/retenciones', redirectTo: 'retencion' },
    { path: 'facturacion/percepciones', redirectTo: 'percepcion' },
    { path: 'facturacion', redirectTo: 'facturador', pathMatch: 'full' },
    { path: 'facturacion/:legacy', redirectTo: 'facturador' },
    { path: 'facturacion/:legacy/:detail', redirectTo: 'facturador' },

    { path: 'reportes/ventas', redirectTo: 'dashboard' },
    { path: 'reportes', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: 'reportes/:legacy', redirectTo: 'dashboard' },
    { path: 'reportes/:legacy/:detail', redirectTo: 'dashboard' },

    { path: 'productos/lista', redirectTo: 'producto' },
        { path: 'productos', redirectTo: 'producto', pathMatch: 'full' },
        { path: 'productos/:legacy', redirectTo: 'producto' },
    { path: 'clientes/lista', redirectTo: 'cliente' },
        { path: 'clientes', redirectTo: 'cliente', pathMatch: 'full' },
        { path: 'clientes/:legacy', redirectTo: 'cliente' },
        { path: 'configuracion', redirectTo: 'empresas', pathMatch: 'full' },
    { path: 'configuracion/empresa', redirectTo: 'empresas' },
    { path: 'configuracion/usuarios', redirectTo: 'usuarios' },
    { path: 'configuracion/series', redirectTo: 'serie' },
        { path: 'configuracion/:legacy', redirectTo: 'empresas' },
        { path: 'configuracion/:legacy/:detail', redirectTo: 'empresas' },
    { path: 'guias/lista', redirectTo: 'facturador' },
        { path: 'guias', redirectTo: 'facturador', pathMatch: 'full' },
        { path: 'guias/:legacy', redirectTo: 'facturador' },

  { path: 'consultacomprobante', component: ConsultacomprobanteComponent },
    { path: 'login', component: LoginComponent },
    // { path: 'loginEmpresa', component: LoginEmpresaComponent },
  //  { path: 'facturador', component: EntradasComponent },
    { path: 'consultacomprobante', component: ConsultacomprobanteComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'resetPass', component: RecpasswordComponent },
    { path: 'regModal', component: RegistraModalComponent },
    { path: 'change/:token', component: ChangepasswordComponent },
    {
        path: '',
        component: SeguridadComponent,
        canActivate: [ LoginGuardGuard ],
        loadChildren: () => import('./modulos/seguridad/seguridad.module').then(m => m.SeguridadModule)
    },
    {
        path: '',
        component: EntradasComponent,
        canActivate: [ LoginGuardGuard ],
        loadChildren: () => import('./modulos/entradas/entradas.module').then(m => m.EntradasModule)
    },
    {
        path: '',
        component: CargaMasivaComponent,
        canActivate: [ LoginGuardGuard ],
        loadChildren: () => import('./modulos/carga-masiva/carga-masiva.module').then(m => m.CargaMasivaModule)
    },
    {
        path: '',
        component: MonitoreoComponent,
        canActivate: [ LoginGuardGuard ],
        loadChildren: () => import('./modulos/monitoreo/monitoreo.module').then(m => m.MonitoreoModule)
    },
    { path: '**', component: NopagefoundComponent }
];


export const APP_ROUTES = RouterModule.forRoot( appRoutes, { useHash: false } );
